import { Component, Input } from "@angular/core";
import { ApiService } from "./services/api.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  constructor(private api: ApiService) {}

  verificaLogin() {
    let auth = this.api.isAuthenticated.getValue();
    if (auth.authenticated) {
      return auth.authenticated;
    }
  }
}
